import { DistanceMeasurementComponent, HelpLinesComponentVisible, PlannerEcsMultiSystem, ProductType } from '@inter-ikea-storageone/range';
import { ComponentIds } from '@inter-ikea-core/core';
import { Direction } from '@inter-ikea-storageone/range/src/core-api/components/DistanceMeasurementComponent';
/**
 * Disables distance measurement for frames in help lines are enabled
 */
export class DisableFrameDistanceMeasurementSystem extends PlannerEcsMultiSystem {
    constructor(coreApi) {
        super(coreApi, 'DisableFrameDistanceMeasurementSystem', [
            HelpLinesComponentVisible.id,
            ComponentIds.IN_SCENE_COMPONENT_ID
        ]);
        this.platsaFrameTypes = [
            ProductType.PLATSA_FRAME,
            ProductType.PLATSA_OPEN_FRAME_HANGING,
            ProductType.PLATSA_OPEN_FRAME_SHELVES,
            ProductType.PLATSA_OPEN_FRAME_SHOES
        ];
    }
    onAdd(entity, newComponent) {
        switch (newComponent.typeId) {
            case HelpLinesComponentVisible.id:
                if (newComponent.visible) {
                    this.updateFrameDistanceMeasurement(false);
                }
                break;
            case ComponentIds.IN_SCENE_COMPONENT_ID:
                if (this.coreApi.entities.isOneOfProductTypes(entity, this.platsaFrameTypes) &&
                    this.coreApi.entities
                        .getScene()
                        ?.getComponent(HelpLinesComponentVisible.id)?.visible) {
                    entity.removeComponent(DistanceMeasurementComponent.id);
                }
        }
    }
    onUpdate(entity, oldComponent, newComponent) {
        switch (newComponent.typeId) {
            case HelpLinesComponentVisible.id:
                if (newComponent.visible) {
                    this.updateFrameDistanceMeasurement(false);
                }
                else {
                    this.updateFrameDistanceMeasurement(true);
                }
        }
    }
    onRemove(entity, oldComponent) {
        switch (oldComponent.typeId) {
            case HelpLinesComponentVisible.id:
                this.updateFrameDistanceMeasurement(true);
        }
    }
    updateFrameDistanceMeasurement(enable) {
        const frames = this.coreApi.entities.getByProductTypes(this.platsaFrameTypes);
        if (enable) {
            frames.forEach(frame => frame.addComponent(new DistanceMeasurementComponent([Direction.UP, Direction.DOWN, Direction.LEFT, Direction.RIGHT], [], true)));
        }
        else {
            frames.forEach(frame => frame.removeComponent(DistanceMeasurementComponent.id));
        }
    }
}
//# sourceMappingURL=DisableFrameDistanceMeasurementSystem.js.map